import { Component, inject } from '@angular/core';
import { BUILDIG_LAYOUT } from './building-layout-token';
import { NgComponentOutlet } from '@angular/common';

/**
 * Decouples building pages from layout implementation by dynamically providing the building layout component.
 *
 * This provider allows domain modules to use the building layout without creating cross-domain dependencies.
 * The actual layout component is injected via the BUILDIG_LAYOUT token and rendered dynamically.
 */
@Component({
  selector: 'cfp-building-layout-provider',
  template: '<ng-container *ngComponentOutlet="layoutComponent" />',
  imports: [NgComponentOutlet]
})
export class BuildingLayoutProvider {
  public readonly layoutComponent = inject(BUILDIG_LAYOUT);
}
